import React, { ChangeEvent, KeyboardEvent, useState } from "react"

import { styled } from "@mui/material/styles"

import { ActionIcon } from "../ActionIcon"
import { MuiIcon } from "../MuiIcon"
import { TextField } from "../TextField"

interface IProps {
  value: string,
  isEditMode: boolean,
  inputRef?: (element: HTMLInputElement) => void,
  showEditIcon?: boolean,
  onChange?: (value: string) => void,
  onApply?: (value: string) => void,
  multiline?: boolean
}

export const EditableString = ({ value, isEditMode, inputRef, showEditIcon = false, onChange, onApply, ...props }: IProps) => {

  const [currentValue, setCurrentValue] = useState<string>(value)

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key !== "Enter") {
      return
    }

    event.preventDefault()
    onApply?.(currentValue)
  }

  return <StyledEditableString
    {...props}
    defaultValue={value}
    multiline={props.multiline}
    disableUnderline
    onKeyDown={onKeyDown}
    onInput={(event: ChangeEvent<HTMLInputElement>) => {
      onChange?.(event.target.value)
      setCurrentValue(event.target.value)
    }}
    startAdornment={isEditMode && showEditIcon
      ? <ActionIcon
        icon={MuiIcon.ModeEdit}
        sx={{ color: "#008859" }} />
      : null}
    disabled={!isEditMode}
    inputRef={inputRef} />
}

const StyledEditableString = styled(TextField)(({ multiline }) => ({
  fontSize: "16px",
  lineHeight: "20px",
  width: "fit-content",

  "& .MuiFilledInput-root": {
    padding: 0,
    margin: 0,
    width: "fit-content",
    height: multiline ? "fit-content" : "20px",
    background: "transparent",
    color: "#1A1A1A",

    "&.Mui-disabled, &.Mui-focused, &:hover": {
      backgroundColor: "transparent"
    },

    "& .MuiFilledInput-input": {
      caretColor: "#008859",
      padding: 0,
      background: "transparent",
      "-webkit-text-fill-color": "#1A1A1A"
    },

    "& .MuiInputAdornment-positionStart": {
      display: "none"
    }
  }
}))
